// utils/logout.js
import { signOut } from 'firebase/auth';
import { auth } from '../../pages/app/protected/firebase';

export const handleAdminLogout = async (navigate) => {
  try {
    await signOut(auth);
    navigate('/');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};